import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-value"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for", "aria-label", "innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", { "data-value": $props.modelValue }, [
    _createElementVNode("input", {
      id: `date-${$props.value}`,
      ref: "inputRef",
      type: "radio",
      onChange: _cache[0] || (_cache[0] = $event => (_ctx.$emit('selected')))
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
    _createCommentVNode(" biome-ignore lint/a11y/noLabelWithoutControl: Aria Label provided using binding "),
    _createElementVNode("label", {
      for: `date-${$props.value}`,
      "aria-label": $props.value,
      innerHTML: $props.content
    }, null, 8 /* PROPS */, _hoisted_3)
  ], 8 /* PROPS */, _hoisted_1))
}